import axios from "axios";


const msmartAxios = axios.create({
    baseURL: process.env.REACT_APP_MSMART
})

const mbotAxios = axios.create({
    baseURL: process.env.REACT_APP_MBOT
})

const fileServerAxios = axios.create({
    baseURL: process.env.REACT_APP_FILE_SERVER
})

const muAxios = axios.create({
    baseURL: process.env.REACT_APP_MU
})

const serverAxios = axios.create({
    baseURL: process.env.REACT_APP_SERVER
});

// Sesi user tak sah lagi (token rosak / akaun dipadam atau dicipta semula):
// buang token simpanan dan pergi ke /login, supaya page tak tersekat dengan error 401 berulang.
// Hanya untuk request yang bawa accessToken; request admin & error lain tak disentuh.
const SESSION_CODES = ["SESSION_EXPIRED", "SESSION_INVALID"];
let redirecting = false;

const handleSessionError = (error) => {
    const status = error?.response?.status;
    const code = error?.response?.data?.code;
    const sentUserToken = !!error?.config?.headers?.accessToken;

    if (status === 401 && SESSION_CODES.includes(code) && sentUserToken && !redirecting) {
        redirecting = true;
        localStorage.removeItem("accessToken");
        localStorage.removeItem("validToken");
        if (!window.location.pathname.startsWith("/login")) {
            window.location.assign("/login");
        }
    }
    return Promise.reject(error);
};

[msmartAxios, mbotAxios, fileServerAxios, muAxios, serverAxios].forEach((instance) =>
    instance.interceptors.response.use((response) => response, handleSessionError)
);

export {msmartAxios, mbotAxios, fileServerAxios, muAxios}

export default serverAxios;
